<script>
    import Select from "svelte-select";

    export let zips = [];
    export let value;
    export let handleChange;
    export let required = true;
    export let placeholder;
    export let error;
    export let name;
    export let clearable = false;

</script>

<div class="w-full">
    <Select
        items={zips}
        id="cap"
        type="text"
        placeholder={placeholder}
        on:change={handleChange}
        on:blur={handleChange}
        bind:value={value}
        required={required}
        disabled={zips?.length === 0 && !value}
        {name}
        bind:clearable={clearable}
        class="hover:shadow-md transition-all select-error-border"
        containerStyles={`
            border-radius: 0px;
            border: 1px solid #e0e0e0;
            box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%);
            max-height: 2.75rem`
        }
    />

    {#if error}
        <div class="pl-3 text-red-500">{error}</div>
    {/if}
</div>
